import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import classNames from 'classnames';
// Kopierat från react-bootstrap 1.5.2 med tillägg för bootstrap 5
import omit from 'lodash/omit';
const DEVICE_SIZES = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
export const Col = /*#__PURE__*/ React.forwardRef(({ className, componentClass: Component = 'div', ...props }, ref)=>{
    const spans = [];
    const classes = [];
    DEVICE_SIZES.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue !== null && propValue !== undefined) {
            ({ span = true, offset, order } = propValue);
        } else {
            span = propValue;
        }
        const infix = brkPoint !== 'xs' ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `col${infix}` : `col${infix}-${span}`);
        if (order !== null && order !== undefined) classes.push(`order${infix}-${order}`);
        if (offset !== null && offset !== undefined) classes.push(`offset${infix}-${offset}`);
    });
    if (!spans.length) {
        spans.push('col'); // plain 'col'
    }
    const propsToPass = useMemo(()=>omit(props, ...DEVICE_SIZES), [
        props
    ]);
    return /*#__PURE__*/ _jsx(Component, {
        ...propsToPass,
        ref: ref,
        className: classNames(className, ...spans, ...classes)
    });
});
Col.displayName = 'Col';
